import { handleSelectProcedure } from '../../modules/events/consultListeners';
import { surgicalOption } from '../../utils/variables';

export function loadSelectSearchProcedure(procedures) {
    const list = document.querySelector(
        '.requestConsult__container .procedure__menu .procedure__select'
    );
    list.innerHTML = '';

    let result = ``;
    const filteredProcedures = procedures ? procedures.filter((i) => {
        if(surgicalOption === null) {
            return i.online_booking;
        }
        if(!surgicalOption) {
            return i.surgical === 0 && i.online_booking;
        } else {
            return i.surgical === 1 && i.online_booking;
        }
    }) : [];
    if (filteredProcedures.length > 0) {
        for (const i of filteredProcedures) {
            result = result.concat(`
            <li class="procedure__option" data-procedure-id="${i.id}">${i.name}</li>
            `);
        }
    }

    let menuDropdownProcedures = document.querySelector('.requestConsult__container .procedure__menu');
    if(result) {
        menuDropdownProcedures.classList.remove('non-boxShadow');
    }else {
        menuDropdownProcedures.classList.add('non-boxShadow');
    }

    list.insertAdjacentHTML('beforeend', result);
    handleSelectProcedure();
}
